import React, {useCallback, useState} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {SVGICONS} from '@ey/icons';
import {IconoirPage, IconoirCustomUpdate, IconoirGridPlus} from '@ey-xd/motif-icon';
import Icon from '../../Common/BaseComponentWrappers/MotifIcon';
import {labels} from '../../../util/utils';
import {ViewModes} from '../../../util/uiconstants';
import Ellipses from '../../Common/EllipsesControl/EllipsesPresets';
import MotifTooltip from '../BaseComponentWrappers/MotifTooltip';

function CanvasFormViewType({viewTypeOptions, page, setPage, isExpanded, onFormViewTypeClick}) {
	const railNavigationConfig = {
		[ViewModes.Form]: {
			label: labels.questionsAndResponses,
			iconName: 'formIcon',
			iconSrc: IconoirPage,
			// iconName: 'IconoirPage',
			key: 'form'
		},
		[ViewModes.Changes]: {
			label: labels.trackChanges,
			iconName: 'changesIcon',
			iconSrc: IconoirCustomUpdate,
			// iconName: 'IconoirCustomUpdate',
			key: 'changes'
		},
		[ViewModes.Details]: {
			label: labels.attributes,
			iconName: 'detailsIcon',
			iconSrc: IconoirGridPlus,
			// iconName: 'IconoirGridPlus',
			key: 'details'
		}
	};

	// This is to force the tooltip control to hide after clicking on the icon
	const [forceHide, setForceHide] = useState(false);

	const handleOnFormViewTypeClick = useCallback((viewTypeId, evt) => {
		onFormViewTypeClick && onFormViewTypeClick(viewTypeId, evt);
		setForceHide((prevForceHide) => !prevForceHide);
		setPage && setPage(viewTypeId);
	}, []);

	// Conditions for hiding the component
	if (viewTypeOptions?.length === 0) {
		return null;
	}

	return (
		<StyledCanvasFormViewType className={`StyledCanvasFormViewType whiteBottomBorder ${isExpanded ? '' : 'collapsed'}`}>
			{viewTypeOptions.map((viewType) => {
				const viewTypeOption = railNavigationConfig[viewType];
				const isSelected = viewType === page;

				let additionalClasses = '';
				additionalClasses += isSelected ? ' selected' : '';
				additionalClasses += isExpanded ? '' : ' collapsed-icon';

				const icon = (
					<section className="view-type-icon">
						<Icon src={viewTypeOption.iconSrc} />
						{/* <SVGICONS styleName={isExpanded ? 'large' : 'medium'} name={viewTypeOption.iconName} /> */}
						{/* <Icon iconFunction={viewTypeOption.iconName} className={isExpanded ? 'large' : 'medium'} /> */}
					</section>
				);

				return (
					<section
						key={viewType}
						className={`view-type-icon-container${additionalClasses !== '' ? additionalClasses : ''}`}
						onClick={(evt) => handleOnFormViewTypeClick(viewType, evt)}
					>
						{isExpanded ? (
							<>
								{icon}
								<section title={viewTypeOption.label} className="view-type-icon-label">
									<Ellipses.Single useTextTruncate>{viewTypeOption.label}</Ellipses.Single>
								</section>
							</>
						) : (
							<MotifTooltip
								id={`${viewTypeOption.key}-icon`}
								className="view-type-icon-tooltip"
								trigger={icon}
								hideCloseButton
								forceHideCounter={forceHide}
								variant="alt"
							>
								{viewTypeOption.label}
							</MotifTooltip>
						)}
					</section>
				);
			})}
		</StyledCanvasFormViewType>
	);
}

CanvasFormViewType.propTypes = {
	viewTypeOptions: PropTypes.arrayOf(PropTypes.number),
	page: PropTypes.number,
	setPage: PropTypes.func,
	isExpanded: PropTypes.bool,
	onFormViewTypeClick: PropTypes.func
};

const StyledCanvasFormViewType = styled.section`
	display: flex;
	flex-direction: column;
	width: 100%;
	font-size: var(--px-14);
	padding: var(--px-16) 0;
	&.whiteBottomBorder {
		border-bottom: var(--px-1) solid var(--neutrals-100);
	}
	&.collapsed {
		padding: 0 !important;
		border: 0 !important;
	}
	.view-type-icon-container {
		display: flex;
		flex-direction: row;
		color: var(--neutrals-700);
		padding: var(--px-8) var(--px-20) var(--px-8) 0;
		cursor: pointer;
		&.selected {
			color: var(--teal-600);
			svg {
				color: var(--teal-600) !important;
				fill: var(--teal-600) !important;
			}
		}
		&:hover {
			svg {
				fill: var(--teal-600) !important;
				color: var(--teal-600) !important;
			}
			.view-type-icon-label {
				color: var(--teal-600) !important;
			}
		}
		.view-type-icon {
			svg {
				width: var(--px-20);
				height: var(--px-20);
				fill: var(--neutrals-700);
				color: var(--neutrals-700);
			}
		}
		.view-type-icon-label {
			margin-left: var(--px-8);
			font-size: var(--px-14);
			font-weight: 400;
			width: 85%;
			.ellipses-multilines {
				width: 100%;
				display: inline-block;
			}
		}
	}
`;

export default CanvasFormViewType;
